export type PointExpirationScheduleItem = {
  date: string;
  points: number;
};

export type GroupedExpirations = {
  expiringSoon: PointExpirationScheduleItem[];
  expiringNext: PointExpirationScheduleItem[];
};

export const DEFAULT_NOTIFICATION_DAYS = 30;

export const MILLISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;

export const groupExpirationsByDate = (
  schedule: PointExpirationScheduleItem[],
  notificationDays: number | null | undefined,
): GroupedExpirations => {
  if (!notificationDays) {
    return { expiringSoon: [], expiringNext: schedule };
  }

  const notificationThreshold = new Date(Date.now() + notificationDays * MILLISECONDS_IN_A_DAY);

  const expiringSoon: PointExpirationScheduleItem[] = [];
  const expiringNext: PointExpirationScheduleItem[] = [];

  schedule.forEach((item) => {
    const expirationDate = new Date(item.date);
    if (expirationDate <= notificationThreshold) {
      expiringSoon.push(item);
    } else {
      expiringNext.push(item);
    }
  });

  return { expiringSoon, expiringNext };
};
